import { render, staticRenderFns } from "./dormDistribute.vue?vue&type=template&id=cdaf5dde"
import script from "./dormDistribute.vue?vue&type=script&lang=js"
export * from "./dormDistribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports